import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { toggleProduct } from 'funnel/actions/product';
import ProductList from 'funnel/components/detail/products/ProductList';

const mapStateToProps = state => ({
  products: state.funnels.products.items.toArray(),
});
const mapDispatchToProps = dispatch => ({
  toggleProduct: id => dispatch(toggleProduct(id)),
});
const FunnelProductsPage = ({ products, toggleProduct }) => (
  <div>
    <ProductList products={products} onToggle={toggleProduct} />
  </div>
);

FunnelProductsPage.propTypes = {
  products: PropTypes.array.isRequired,
  toggleProduct: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelProductsPage);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/FunnelProductsPage.js